import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M3 12a9 9 0 1 0 18 0a9 9 0 1 0 -18 0","key":"svg-0"}],["path",{"d":"M9 8l1 8l2 -5l2 5l1 -8","key":"svg-1"}]]

const IconCircleLetterW = createReactComponent('outline', 'circle-letter-w', 'CircleLetterW', __iconNode);

export default IconCircleLetterW;